import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  snapDefaultSupporter,
  unSnapDefaultSupporter,
} from "store/user/(default)/supporter/default_supporter.action";
//
//component
//redux
//selector
//actions
export const TriggerInit = () => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    dispatch(snapDefaultSupporter());
    return () => dispatch(unSnapDefaultSupporter());
  }, [dispatch]);
  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerInit;
